import { render, staticRenderFns } from "./notificationSuccessIcon.vue?vue&type=template&id=0a5fe011&"
import script from "./notificationSuccessIcon.vue?vue&type=script&lang=js&"
export * from "./notificationSuccessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports